import { Role } from 'api/models';
import {
  DemandRole,
  SchedulerResourceType,
  TotalTeamAllocation,
  TotalAllocation,
  TotalUserAllocation,
  UserCountByUserType,
} from '../resource-types';
import { concat } from './common';
import { resourceIdForDemandResource } from './id';

const getUserTotalAllocationsTree = (
  roleId: number,
  softAllocationsEnabled?: boolean,
): TotalUserAllocation[] =>
  softAllocationsEnabled
    ? [
        {
          type: SchedulerResourceType.UserTotalHardAllocation,
          id: resourceIdForDemandResource(
            roleId,
            SchedulerResourceType.UserTotalHardAllocation,
          ),
          rowHeight: 48,
          roleId,
        },
        {
          type: SchedulerResourceType.UserTotalSoftAllocation,
          id: resourceIdForDemandResource(
            roleId,
            SchedulerResourceType.UserTotalSoftAllocation,
          ),
          rowHeight: 48,
          roleId,
        },
      ]
    : [
        {
          type: SchedulerResourceType.UserTotalAllocation,
          id: resourceIdForDemandResource(
            roleId,
            SchedulerResourceType.UserTotalAllocation,
          ),
          rowHeight: 48,
          roleId,
        },
      ];

const getTeamTotalAllocationsTree = (
  roleId: number,
  softAllocationsEnabled?: boolean,
): TotalTeamAllocation[] =>
  softAllocationsEnabled
    ? [
        {
          type: SchedulerResourceType.TeamTotalHardAllocation,
          id: resourceIdForDemandResource(
            roleId,
            SchedulerResourceType.TeamTotalHardAllocation,
          ),
          rowHeight: 48,
          roleId,
        },
        {
          type: SchedulerResourceType.TeamTotalSoftAllocation,
          id: resourceIdForDemandResource(
            roleId,
            SchedulerResourceType.TeamTotalSoftAllocation,
          ),
          rowHeight: 48,
          roleId,
        },
      ]
    : [
        {
          type: SchedulerResourceType.TeamTotalAllocation,
          id: resourceIdForDemandResource(
            roleId,
            SchedulerResourceType.TeamTotalAllocation,
          ),
          rowHeight: 48,
          roleId,
        },
      ];

const getTotalAllocationTree = (
  roleId: number,
  softAllocationsEnabled?: boolean,
): TotalAllocation => ({
  type: SchedulerResourceType.TotalAllocation,
  id: resourceIdForDemandResource(
    roleId,
    SchedulerResourceType.TotalAllocation,
  ),
  rowHeight: 48,
  roleId,
  children: concat(
    getUserTotalAllocationsTree(roleId, softAllocationsEnabled),
    getTeamTotalAllocationsTree(roleId, softAllocationsEnabled),
  ),
});

export const convertRolesIntoResourceTree = (
  roles: Role[],
  roleToUserCount: Record<number, number>,
  roleToUserCountByUserType: Record<number, UserCountByUserType>,
  softAllocationsEnabled?: boolean,
): DemandRole[] => {
  return roles.map(({ roleId, roleName }) => ({
    type: SchedulerResourceType.DemandRole,
    id: resourceIdForDemandResource(roleId, SchedulerResourceType.DemandRole),
    roleId,
    roleName,
    rowHeight: 48,
    userCount: roleToUserCount[roleId],
    userCountByUserType: roleToUserCountByUserType[roleId],
    children: [
      {
        type: SchedulerResourceType.DemandCapacity,
        id: resourceIdForDemandResource(
          roleId,
          SchedulerResourceType.DemandCapacity,
        ),
        rowHeight: 48,
        roleId,
      },
      getTotalAllocationTree(roleId, softAllocationsEnabled),
    ],
  }));
};
